import Button from "components/Button";
import Modal from "components/Modal";
import React from "react";
import ArrowLeft from "icons/arrow-circle-left-green.svg";
import Confirm from "icons/confirm-circle-white.svg";
import { editEntity } from "services/entity";
import { useHistory } from "react-router-dom";
import toastMessage from "helpers/handleToastMessage";
import { ToastContainer } from "react-toastify";

type Props = {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  enabled: any;
  setEnabled: React.Dispatch<React.SetStateAction<any>>;
  changeStatus: string;
  setChangeStatus: React.Dispatch<React.SetStateAction<string>>;
  reloadList: () => void;
};

const ModalStatus: React.FC<Props> = ({
  show,
  setShow,
  setLoading,
  enabled,
  setEnabled,
  changeStatus,
  setChangeStatus,
  reloadList,
}): JSX.Element => {
  let history = useHistory();

  const editStatus = async () => {
    try {
      setLoading(true);
      Object.assign(enabled, { subtype: "agency" });
      Object.assign(enabled, { status: changeStatus });
      await editEntity(enabled, enabled._id);

      toastMessage({
        message: "Change status successfully.",
        type: "success",
      });

      if (changeStatus === "active") {
        history.push(`/entity-management/${enabled._id}/edit`);
      }
    } catch (error: any) {
      toastMessage({
        message: "Error, Something went wrong.",
        type: "error",
      });
    } finally {
      reloadList();
      setChangeStatus("");
      setEnabled(null);
      setShow(false);
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      children={
        <div className="w-full h-44 bg-bt-white p-6 rounded-md">
          <div className="flex flex-row items-center justify-center">
            <span className="font-nunito font-light text-xl text-bt-black">
              Do you really want to change the status of the current user?
            </span>
          </div>
          <div className="flex flex-row justify-around mt-10 mb-10">
            <div className="flex flex-col">
              <Button
                label={"Back"}
                iconLeft={ArrowLeft}
                className="bg-bt-white text-bt-green border border-bt-green h-10 w-28 font-sora rounded-full"
                onClick={() => setShow(false)}
              />
            </div>
            <div className="flex flex-col">
              <Button
                label={"Confirm"}
                iconLeft={Confirm}
                className="bg-bt-green text-bt-white h-10 w-28 font-sora rounded-full"
                onClick={() => editStatus()}
              />
            </div>
          </div>
          <ToastContainer />
        </div>
      }
    />
  );
};

export default ModalStatus;
